import { render } from "./NotificationHeader.vue?vue&type=template&id=d41994c0&ts=true"
import script from "./NotificationHeader.vue?vue&type=script&lang=ts"
export * from "./NotificationHeader.vue?vue&type=script&lang=ts"

import "./NotificationHeader.vue?vue&type=style&index=0&id=d41994c0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__